import { useState } from 'react';
import { deleteSite, DeleteSiteResult } from '../../apis/sitesApi'

export const useDeleteSite = () => {
  const [loading, setLoading] = useState(false);

  /**
   * Deletes a site. If it still has active schedules the API answers 409 and
   * this resolves to 'needs-confirmation' instead of deleting - prompt the user
   * with the returned message, then call again with force = true.
   */
  const deleteSiteData = async (
    id: number,
    refetch: any,
    force = false
  ): Promise<DeleteSiteResult | false> => {
    setLoading(true);
    try {
      const result = await deleteSite(id, force);
      if (result.status === 'deleted') {
        refetch();
      }
      return result;
    } catch (error) {
      console.error('Failed to delete site:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };
  return { deleteSiteData, loading };
};
